// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2uBI0","errorLogs":"styles_errorLogs__3K0og"};